import { render, staticRenderFns } from "./CommonLabel.vue?vue&type=template&id=11f7087a"
import script from "./CommonLabel.vue?vue&type=script&lang=js"
export * from "./CommonLabel.vue?vue&type=script&lang=js"
import style0 from "./CommonLabel.vue?vue&type=style&index=0&id=11f7087a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports